import { URLs } from "./settings";

export default function AppMultilanguageText() {
  const apiURL = `${URLs.apiUrl}/appMultilanguageText`;

  return fetch(apiURL)
    .then((res) => res.json())
    .then((res) => res);
}
